import createRoute           from '@widesk-ui/tools/createRoute';
import PushNotificationModel from '@models/website/PushNotificationModel';

const route = createRoute.splitView(
	'/website_entertainments/:websiteEntertainmentId/push_notifications',
	'website',
	'PushNotificationSplitView',
	PushNotificationModel.localize('plural'),
);
export default route;
